<template>
  <div style="display: flex; justify-content: space-between;width: 100%;">
    <a-form style="width: 100%">
      <a-row style="width: 100%">
        <a-col :span="10">
          <a-form-item label="KEY值" name="itemKey" :labelCol="{ span: 4 }">
            <a-input
              v-model:value="globalKey"
              placeholder="仅支持全局搜索"
              allowClear
            />
          </a-form-item>
        </a-col>
        <a-col :span="2" :offset="1">
          <a-button
            type="primary"
            @click="handleGlobalSearch"
            :disabled="globalKey === ''"
            >全局查询</a-button
          >
        </a-col>
        <a-col :span="11">
          <div style="text-align: right;">
            <a-button
              class="mr10"
              type="primary"
              @click="$emit('KeyModal', { opera: 'add' })"
            >
              新增key值
            </a-button>
            <a-button type="default" @click="selectImport">
              批量维护
            </a-button>
          </div>
        </a-col>
      </a-row>
    </a-form>
  </div>
  <a-modal
    v-model:visible="isVisible1"
    title="个性化设置"
    @ok="handleOk"
    okText="保存"
    cancelText="取消"
    :confirm-loading="confirmLoading"
  >
    <div class="wrap">
      <div style="margin-bottom: 8px;">
        <h4 style="margin-bottom: 8px;">用户维度</h4>
        <a-checkbox v-model:checked="prompt"
          >新建collection后，自动弹出推送终端提示</a-checkbox
        >
      </div>
      <div>
        <h4 style="margin-bottom: 8px;">站点维度</h4>
        <a-checkbox v-model:checked="sync"
          >权重排序时，权重基础分自动同步web端</a-checkbox
        >
      </div>
    </div>
  </a-modal>
  <a-modal v-model:visible="importVisible" title="批量维护">
    <div style="text-align: center;padding: 40px 0;">
      <a-space :size="40" type="flex" align="center">
        <a-upload
          v-model:file-list="fileList"
          name="file"
          :multiple="true"
          :customRequest="uploadHandleChange"
        >
          <a-button type="default" :disabled="productDis">
            导入
          </a-button>
        </a-upload>
        <a-button type="primary" @click="exportAll">导出</a-button>
      </a-space>
    </div>

    <template #footer>
      <a-button @click="close">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
import { inject, reactive, toRefs, watch, watchEffect, onMounted } from 'vue'
import {
  collection_special_save,
  collection_special_query
} from '@/server/modules/41299.js'
import { message } from 'ant-design-vue'
import { formRequest } from 'cupshe-axios'
import { export_all_post } from '../../../server/modules/8997'
export default {
  emits: ['KeyModal'],
  setup() {
    const initData = inject('initState')
    const state = reactive({
      productDis: process.env.VUE_APP_TASK_ENV === 'production',
      fileList: [],
      importVisible: false,
      isVisible1: false,
      checked: true,
      prompt: true,
      sync: true,
      confirmLoading: false,
      configParams: {
        prompt: '',
        sync: '',
        promptId: '',
        syncId: '',
        siteId: ''
      },
      exportAll: async () => {
        const { success, retInfo } = await export_all_post({
          categoryId: initData.postParams.categoryId
        })
        console.log(success)
        if (success) {
          message.success('导出成功')
          state.importVisible = false
        } else {
          message.error(retInfo)
        }
      },
      uploadHandleChange: async info => {
        if (info && info.file) {
          const { data, success, retInfo } = await formRequest(
            `${process.env.VUE_APP_I18N}i18n/key/import/${initData.postParams.categoryId}`,
            {
              file: [info.file]
            }
          )
          if (success) {
            console.log(data)
            message.success('上传成功')
            info.onSuccess(retInfo, info)
            state.fileList = []
            initData.resetPagination()
            state.importVisible = false
          } else {
            message.error(retInfo)
            info.onError(retInfo)
            state.fileList = []
          }
        }
      },
      selectImport() {
        state.importVisible = true
      },
      close() {
        state.importVisible = false
      },
      // computed(() => ({
      //   prompt: state.prompt ? 0 : 1, //是否弹出终端提示 0-不弹出，1-弹出
      //   sync: state.sync ? 1 : 0 // 是否同步web端权重原始值， 0-不同步，1-同步
      // })),
      handleOk() {
        state.saveCollectionConifg()
      },
      showModal() {
        state.getCollectionConfig()
        state.isVisible1 = true
      },
      async saveCollectionConifg() {
        try {
          state.confirmLoading = true
          const params = {
            ...state.configParams
          }
          params.prompt = state.prompt ? 1 : 0
          params.sync = state.sync ? 1 : 0
          params.siteId = initData.searchParams.siteId

          let { success, retInfo } = await collection_special_save(params, {
            isFilter: true
          })
          if (success) {
            state.isVisible1 = false
            state.getCollectionConfig()
          } else {
            message.error(retInfo)
          }
          state.confirmLoading = false
        } catch (error) {
          console.log('error', error)
          state.confirmLoading = false
        }
      },
      async getCollectionConfig() {
        let { success, data, retInfo } = await collection_special_query(
          initData.searchParams.siteId
        )
        if (success) {
          state.configParams = data
          state.prompt = data.prompt === 1 ? true : false
          state.sync = data.sync === 1 ? true : false
        } else {
          message.error(retInfo)
        }
      }
    })
    onMounted(() => {
      //if (process.env.NODE_ENV === 'production') state.productDis = true
    })
    watchEffect(() => {
      if (initData.searchParams.siteId) {
        state.getCollectionConfig()
      }
    })
    watch(
      () => initData.searchParams.brandId,
      n => {
        if (n) {
          initData.searchParams.channelId = undefined
          initData.searchParams.siteId = undefined
          initData.searchParams.terminalId = undefined
          initData.channels = initData.siteArr.find(
            v => v.brandId === n
          )?.channels
        }
      }
    )
    watch(
      () => initData.searchParams.channelId,
      n => {
        if (n) {
          initData.searchParams.siteId = undefined
          initData.searchParams.terminalId = undefined
          initData.sites = initData.channels.find(v => v.channelId === n)?.sites
        }
      }
    )
    watch(
      () => initData.searchParams.siteId,
      n => {
        if (n) {
          initData.searchParams.terminalId = undefined
          const site = initData.sites.find(v => v.siteId === n)
          initData.searchParams.siteCode = site?.siteCode
          initData.terminals = site?.terminals
        }
      }
    )

    watch(
      () => initData.searchParams.terminalId,
      n => {
        if (n) {
          initData.resetSiteInfo(
            initData.terminals.find(
              v => v.terminalId === initData.searchParams.terminalId
            )
          )
        }
      }
    )
    return {
      ...toRefs(initData),
      ...toRefs(state)
    }
  }
}
</script>
<style scoped>
.fourElements {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
